module.exports = __webpack_public_path__ + "static/img/driving.431610a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/driving.png
// module id = MnMS
// module chunks = 0